import React from 'react';
import { SvgIcon } from '@material-ui/core';

const Lock = props => (
    <SvgIcon shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="nonzero" clipRule="evenodd" viewBox="0 0 10240 10240" {...props}>
	<path id="curve1" d="M5120 652c1767,0 3200,1433 3200,3200l0 948 -1280 0 0 -948c0,-1060 -860,-1920 -1920,-1920 -1060,0 -1920,860 -1920,1920l0 948 -1280 0 0 -948c0,-1767 1433,-3200 3200,-3200z"/>
	<path id="curve0" d="M1920 5120l6400 0c353,0 640,287 640,640l0 3200c0,353 -287,640 -640,640l-6400 0c-353,0 -640,-287 -640,-640l0 -3200c0,-353 287,-640 640,-640zm3200 960c-353,0 -640,287 -640,640 0,201 92,380 237,497l-237 1423 1280 0 -237 -1423c145,-117 237,-296 237,-497 0,-353 -287,-640 -640,-640z"/>
    </SvgIcon>
);
export default Lock;

